<template>
    <v-container v-resize="onResize">
        <v-layout v-if="!loading" row wrap pt-4 align-center>
            <v-flex v-if="this.THISMINISTRY.ImageID != ''" xs12 sm6 class="pa-2 pl-0 pt-0">
                <h2 class="pb-2">{{this.Name}} ({{ this.DATE_FROMTO( this.MinistryStart , this.MinistryEnd )  }})</h2>
                <!-- <v-img :src="imageSrc" aspect-ratio="1" :alt="this.Name" @click="fullSizeImage = true" position="left"  :max-height="400" contain
                    lazy-src="/images/default.jpg"></v-img>
                    <v-btn icon small dark @click="fullSizeImage = true">
                        <v-icon style="color: #333">fullscreen</v-icon>
                    </v-btn> -->
            </v-flex>
            <v-flex xs12 sm6 md6>
                <h2 v-if="this.THISMINISTRY.ImageID == ''" class="pb-3">{{this.Name}} ({{ this.DATE_FROMTO( this.MinistryStart , this.MinistryEnd )  }})</h2>
                <!-- <template>
                    <v-card v-if="statsloading">
                        <v-container fluid>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <div class="loader"></div>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </template>
                 -->
                <!-- <h3 v-if="!statsloading" class="pl-5">Demographics</h3>
                
                <chart v-if="!statsloading" :chartData="ministryPartyDemographics" />
                <chart v-if="!statsloading" :chartData="ministryChamberDemographics" />
                <chart v-if="!statsloading" :chartData="ministryStateDemographics" />
                <chart v-if="!statsloading" :chartData="ministryGenderDemographics" />
                <chart v-if="!statsloading & !hideCabinetChart" :chartData="ministryCabinetDemographics" /> -->
            </v-flex>
            <v-flex xs12 md8>
                <statistical-member-or-senator-selector :value="selectedMpOrSenator" @input="selectedMpOrSenator = $event" />
            </v-flex>                 
            <v-flex xs12 md4>
                <div>
                    <v-text-field :class="{mobileTextField: isMobile}"  v-if="!this.loading" v-on:keyup="TRACK_SEARCH" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    <v-menu v-if="!this.loading && this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                        <v-btn outline small slot="activator">
                            Sort <v-icon>sort</v-icon>
                        </v-btn>
                        <v-list>
                            <v-subheader>Sort by:</v-subheader>
                            <v-list-tile v-for="(item, index) in HEADERS.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                                <v-list-tile-title>
                                    {{ item.text }}
                                    <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </div>
            </v-flex>
        </v-layout>

        <br/>

        <v-layout row wrap align-center justify-space-between>
            <v-btn-toggle v-model="viewType" class="transparent handbook_toggleButton" :mandatory="true">
                <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="handbook_button" :value="'ministers'"><span class="long-button-text chamberButton">Ministers</span></v-btn>
                    </template>
                    <span>Ministers</span>
                </v-tooltip>
                <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="handbook_button" :value="'statements'"><span class="long-button-text chamberButton">Ministerial Statements</span></v-btn>
                    </template>
                    <span>Ministerial Statements</span>
                </v-tooltip>
            </v-btn-toggle>
        </v-layout>       

        <template>
            <v-card v-if="loading">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div class="loader"></div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </template>
        <br>
        <div v-show="!loading" v-if="viewType === 'ministers'">
            <v-data-table
                        :items="MINISTRY"
                        :headers="HEADERS"
                        :footer-props="FOOTER"
                        :rows-per-page-items="ROWS_LISTITEMS"
                        v-on:update:pagination="UPDATE_PAGINATION"
                        :pagination.sync="PAGINATION"
                        :search="search"
                        :hide-headers="isMobile"
                        :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                        disable-initial-sort>

                <template v-slot:items="props">
                    <router-link v-if="isMobile" class="tr" :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.PHID }}" >
                        <td>
                            <div class="flex-content">
                                <div class="flex-item">
                                    <h3 class="pb-xs-1">{{ props.item.DisplayName }}</h3>
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-30">
                                    <div class="flex-item">
                                        <Portrait v-bind:PHID="props.item.PHID" :fixedWidth="80"></Portrait>
                                    </div>
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-70">
                                    <h4>Portfolio</h4>
                                    <ul>
                                    <li v-for="splitRole in props.item.SplitRoles" class="pt-1">
                                        {{ splitRole.FullRole }} ({{ splitRole.DateStart }}–{{ splitRole.DateEnd != '' ? splitRole.DateEnd : 'present' }})
                                    </li></ul>
                                </div>
                                <div class="flex-item" data-label="Member or Senator">
                                    {{ props.item.MPorSenator }}
                                </div>
                            </div>
                        </td>
                    </router-link>
                    <router-link v-else class="tr handbook-tablerow_link" :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.PHID }}" >
                        <td class="text-xs-left"><Portrait v-bind:PHID="props.item.PHID" :fixedWidth="80"></Portrait></td>
                        <td class="text-xs-left">{{ props.item.DisplayName }}</td>
                        <td class="text-xs-left handbook-tablecol_linebreaks" style="white-space: break-spaces;">{{ props.item.FullRole }}</td>
                        <td class="text-xs-left handbook-tablecol_linebreaks">{{ props.item.DateStart }}</td>
                        <td class="text-xs-left handbook-tablecol_linebreaks">{{ props.item.DateEnd }}</td>
                        <td class="text-xs-left">{{ props.item.MPorSenator }}</td>
                    </router-link>
                </template>

                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </template>
            </v-data-table>            
            <v-layout row wrap>
                <v-flex xs12>
                    <div style="float:right">
                        <v-btn  v-on:keyup.enter="EXPORT_MINISTRY_CSV" color="primary">
                            <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                            <span v-on:click="EXPORT_MINISTRY_CSV">&nbsp;Download as CSV</span>
                        </v-btn>
                        <v-btn v-on:keyup.enter="EXPORT_MINISTRY_PDF" color="primary">
                            <v-icon aria-hidden="true" :class="pdfDownloadClass">{{pdfDownloadIcon}}</v-icon>
                            <span v-on:click="EXPORT_MINISTRY_PDF">&nbsp;Download as PDF</span>
                        </v-btn>
                   </div>
                </v-flex>
            </v-layout>
        </div>

        <ministry-ministerial-statements v-if="viewType === 'statements'" :id="MID" :search="search"></ministry-ministerial-statements>

        <v-dialog fullscreen v-model="fullSizeImage">
           <v-card>
        <v-toolbar dark right color="primary">
            <v-toolbar-title class="white--text">{{this.Name}} ({{ this.DATE_FROMTO( this.MinistryStart , this.MinistryEnd )  }})</v-toolbar-title>
             <v-spacer></v-spacer>
          <v-btn icon dark @click="fullSizeImage = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <div style="height: 80vh">
          <v-img :src="imageSrc" :cover="true" :alt="this.Name"
           @click="fullSizeImage = false"></v-img>
          </div>
         </v-card>
          
        </v-dialog>
    </v-container>
     
</template>

<script>
    window.scrollTo(0, 0);
    import Portrait from '@/components/Portrait.vue'
    import Chart from "@/views/StatisticalInformation/Chart.vue";   
    import MinistryMinisterialStatements from '@/views/MinistryMinisterialStatements.vue';
    import StatisticalMemberOrSenatorSelector from '@/views/StatisticalInformation/StatisticalMemberOrSenatorSelector.vue';
    import axios from 'axios'

    export default {
        data() {
            return {
                isMobile: false,
                loading: true,
                statsloading: true,
                search: '',
                pdfDownloading: false,
                csvDownloading: false,
                THISMINISTRY: null,
                MINISTRY_STATS: null,
                hideCabinetChart: false,
                fullSizeImage: false,
                viewType: 'ministers',
                selectedMpOrSenator: ['senator', 'mp'],
                ministryRecords: [],
                ministryRecordsBackup: [],
                ROWS_LISTITEMS: [5, 10, 50, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],

                PAGINATION: {
                    rowsPerPage: this.$store.state.ROWS_PER_PAGE
                },

                HEADERS: [
                    {
                        text: '',
                        value: 'DisplayName',
                        align: 'left',
                        sortable: false,
                    },
                    {
                        text: 'Minister',
                        value: 'DisplayName',
                        align: 'left',
                        sortable: true,
                    },
                    {
                        text: 'Portfolio',
                        value: 'FullRole',
                        align: 'left',
                        sortable: true,

                    },
                    {
                        text: 'Start Date',
                        value: 'DateStart',
                        align: 'left',
                        sortable: true,

                    }
                    ,
                    {
                        text: 'End Date',
                        value: 'DateEnd',
                        align: 'left',
                        sortable: true,

                    },
                    {
                        text: 'Member or Senator',
                        value: 'MPorSenator',
                        align: 'left',
                        sortable: true
                    },
                ],

                FOOTER: [{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus'
                }]
            }
        },

        props: {
            MID: {
                type: Number,
                required: true
            }
        },

        components: {
            Portrait,
            Chart,
            MinistryMinisterialStatements,
            StatisticalMemberOrSenatorSelector
        },
        created() {
            this.loadMinistry();
        },
        mounted() {
            this.onResize();
            //Set page to 10 on mobile, only on mount
            if (this.isMobile){
                this.PAGINATION.rowsPerPage = 10;
            }
        },
        watch: {
            selectedMpOrSenator: function () {
                if (this.selectedMpOrSenator.length == 1) {
                    const selected = this.selectedMpOrSenator[0];
                    switch (selected) {
                        case 'senator':
                            this.ministryRecords = this.ministryRecordsBackup.filter(m => m.MPorSenator == "Senator");
                            break;
                        case 'mp':
                            this.ministryRecords = this.ministryRecordsBackup.filter(m => m.MPorSenator == "Member");
                    }
                }
                else {
                    this.ministryRecords = this.ministryRecordsBackup;
                }
            }
        },
        methods: {
            onResize() {
                if (window.innerWidth < 769){
                    this.isMobile = true;
                }
                else{
                    this.isMobile = false;
                }
            },
            changeSort(column) {
                if (this.PAGINATION.sortBy === column) {
                    this.PAGINATION.descending = !this.PAGINATION.descending
                } 
                else {
                    this.PAGINATION.sortBy = column
                    this.PAGINATION.descending = false
                }
            },
            loadMinistry() {
                this.loading = true;
                this.statsloading = true;
                const url = `ministries?$filter=MID%20eq%20${this.MID}&$select=MID,MIDOrdinal,Name,DateStart,DateEnd,ImageID`;
                const recordUrl = `ministryrecords?$filter=MID%20eq%20${this.MID}`;
                const ministryRequest = axios.get(`api/${url}`)
                const ministryRecordsRequest = axios.get(`api/${recordUrl}`);
                axios.all([ministryRequest, ministryRecordsRequest])
                    .then(response => {
                        this.THISMINISTRY = response[0].data.value[0];
                        this.ministryRecords = response[1].data.value;
                        this.ministryRecordsBackup = response[1].data.value;
                        if (this.THISMINISTRY != null){
                            window.document.title = this.THISMINISTRY.Name;   
                        }
                        this.loading = false;
                    });

                const statsUrl = `StatisticalInformation/Ministry?ministryId=${this.MID}`;
                axios.get(`api/${statsUrl}`)
                .then(response => {
                    this.MINISTRY_STATS = response.data;
                    if (this.MINISTRY_STATS.CabinetMinisters == this.MINISTRY_STATS.Ministers){
                        this.hideCabinetChart = true;
                    }
                    this.statsloading = false;
                });
            },
            TRACK_SEARCH: function () {
                if (this.search.length >= 3) {
                    this.$gtag.event('filter ministry members - search', {
                        'event_category': 'filters',
                        'event_label': this.search,
                        'value': 1
                    });
                }
            },

            UPDATE_PAGINATION: function (options) {
                this.$gtag.event('ministry members pagination items per page', {
                    'event_category': 'filters',
                    'event_label': `items per page: ${options.rowsPerPage}`,
                    'value': 1
                });
                this.$gtag.event('ministry members pagination page', {
                    'event_category': 'filters',
                    'event_label': `page: ${options.page}`,
                    'value': 1
                });
                this.$gtag.event(`ministry members sorting`, {
                    'event_category': 'sorting',
                    'event_label': `sort by ${options.sortBy} ${options.descending ? 'DESC' : 'ASC'}`,
                    'value': 1
                });
                return this.PAGINATION;
            },

            DATE_FROMTO(DateFrom, DateTo) {
                if (DateFrom && DateFrom != 'undefined' && DateFrom != 'Undefined' && DateFrom != '1900-01-01' && DateFrom != '1900-01-1') {
                    DateFrom = '' + this.$moment(String(DateFrom)).format('DD.MM.YYYY')
                } else {
                    DateFrom = ''
                }
                if (DateTo && DateTo != 'undefined' && DateTo != 'Undefined' && DateTo != '1900-01-01' && DateTo != '1900-01-1') {
                    DateTo = ' to ' + this.$moment(String(DateTo)).format('DD.MM.YYYY')
                } else {
                    DateTo = ''
                }
                return DateFrom + DateTo
            },
            EXPORT_MINISTRY_CSV: function () {
                this.$gtag.event('ministry download csv', {
                    'event_category': 'downloads',
                    'event_label': `ministry ${this.Name} csv download`,
                    'value': 1
                });
                
                this.csvDownloading = true;

                let thisMinistry = this.ministryRecords.map(m => ({ ...m, FullRole: `${m.Role}${m.Prep !== '' ? ` ${m.Prep} ${m.Entity}` : ''}` }))
                let OBJ_records = [];
                let headers = ['Name', 'PHID', 'Portfolio', 'Start Date', 'End Date', 'Member or Senator'];
                let isValidToShowCabinetMinister = (this.$moment('1956-01-11') <= this.$moment(this.THISMINISTRY.DateStart) 
                    && this.$moment(this.THISMINISTRY.DateStart) <= this.$moment('1972-12-05'))
                    || this.$moment('1975-12-22') <= this.$moment(this.THISMINISTRY.DateStart);
                let filename = `[${this.MID}] ${this.Name}`
                let index = 0;

                //  then we progressively build up the  exportOBJ
                for (index = 0; index < thisMinistry.length; ++index) {
                    if (thisMinistry[index].FullRole !== "Cabinet Minister" || isValidToShowCabinetMinister) {

                        OBJ_records.push({
                            'Name': thisMinistry[index].DisplayName,
                            'PHID': thisMinistry[index].PHID,
                            'Portfolio': thisMinistry[index].FullRole,
                            'Start Date': this.formatDate(thisMinistry[index].RDateStart, '', 'YYYY-MM-DD', false),
                            'End Date': this.formatDate(thisMinistry[index].RDateEnd, '', 'YYYY-MM-DD', false),
                            'Member or Senator': thisMinistry[index].MPorSenator
                        });
                    }
                }
                this.$store.dispatch('GETCSV', { DATA: OBJ_records, HEADERS: headers, FILENAME: filename })
                    .catch(this.showError)
                    .finally(() => this.csvDownloading = false);
                thisMinistry = null;
                OBJ_records = null;
                index = null;
            },
            EXPORT_MINISTRY_PDF: function () {
                this.$gtag.event('ministry download pdf', {
                    'event_category': 'downloads',
                    'event_label': `ministry ${this.Name} pdf download`,
                    'value': 1
                });
                
                this.pdfDownloading = true;

                let url = `${this.$store.state.URL_API}/document/ministry`;
                let ministryStart = this.MinistryStart ? this.$moment(this.MinistryStart).format('DD.MM.YYYY') : '';
                let ministryEnd = this.MinistryEnd ? this.$moment(this.MinistryEnd).format('DD.MM.YYYY') : '';
                let ministryModel = { MID: this.MID, Name: this.Name, MinistryStart: ministryStart, MinistryEnd: ministryEnd, Ministry: this.MINISTRY }

                axios.post(url, ministryModel, { responseType: 'arraybuffer' })
                    .then((response) => {
                        let blob = new Blob([response.data], { type: 'application/pdf' }),
                            downloadUrl = window.URL.createObjectURL(blob),
                            filename = `Ministry [${this.Name}].pdf`

                        let a = document.createElement("a");
                        if (typeof a.download === "undefined") {
                            window.location.href = downloadUrl;
                        } else {
                            a.href = downloadUrl;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                        }
                        a.remove();
                    }).catch(this.showError)
                    .finally(() => this.pdfDownloading = false);
            }
        },

        computed: {
            // ministryStateDemographics() {
            //     if (this.MINISTRY_STATS.States != null){
                  
            //         const series = this.MINISTRY_STATS.States.map((h) => ({
            //             name: h.Name.toUpperCase(),
            //             data: [h.Count],
            //             pointWidth:50,
            //             visible: true,
            //             showInLegend: false,
            //             groupPadding: 0
            //         }));
            //         const categories = ['State'];

            //         return {
            //             chart: {
            //                 type: 'bar',
            //                 height:60,
            //                 marginLeft: 70,
            //                 backgroundColor: 'rgba(0,0,0,0)'
            //             },
            //             exporting: {
            //                 enabled: false,
            //             },
            //             title: {
            //                 text: ''
            //             },
            //             xAxis: {
            //                 categories: categories,
            //                 minPadding: 0,
            //                 maxPadding: 0
            //             },
            //             yAxis:{
            //                 visible: false,
            //                 minPadding: 0,
            //                 maxPadding: 0
            //             },
            //             tooltip: {
            //                 pointFormat: '<span>{series.name}</span>: <b>{point.y} Ministers</b> ({point.percentage:.0f}%)<br/>',
            //             },
            //             plotOptions: {
            //                 bar: {
            //                     stacking: 'percent'
            //                 }
            //             },
            //             legend: {
            //                 visible: false
            //             },
            //             series: series
            //         };
            //     }

            //     return null;
            // },
            // ministryPartyDemographics() {

            //     if (this.MINISTRY_STATS.Parties != null){

                
            //     const series =  this.MINISTRY_STATS.Parties.map((h) => ({
            //         name: h.Name,
            //         data: [h.Count],
            //         color: h.Colour,
            //         pointWidth:50,
            //         visible: true,
            //         showInLegend: false,
            //          groupPadding: 0
            //     })).reverse();
            //     const categories = ['Party'];

            //     return {
            //         chart: {
            //             type: 'bar',
            //             height:60,
            //         marginLeft: 70,
            //             backgroundColor: 'rgba(0,0,0,0)'
            //         },
            //         exporting: {
            //             enabled: false,
            //         },
            //         title: {
            //             text: ''
            //         },
            //         xAxis: {
            //             categories: categories,
            //             minPadding: 0,
            //             maxPadding: 0
            //         },
            //         yAxis:{
            //             visible: false,
            //             minPadding: 0,
            //             maxPadding: 0
            //         },
            //         tooltip: {
            //             pointFormat: '<span>{series.name}</span>: <b>{point.y} Ministers</b> ({point.percentage:.0f}%)<br/>',
            //         },
            //         plotOptions: {
            //             bar: {
            //                 stacking: 'percent'
            //             }
            //         },
            //         legend: {
            //             visible: false
            //         },
            //         series: series
            //     };
            //     }
            //     return null;
            // },
            // ministryChamberDemographics() {
            //     if (this.MINISTRY_STATS.Chambers != null){

            //         const series = this.MINISTRY_STATS.Chambers.map((h) => ({
            //             name: h.Name,
            //             data: [h.Count],
            //             color: h.Name == "Senate" ? this.$store.state.COLOUR_SENATE : this.$store.state.COLOUR_REPRESENTATIVES,
            //             pointWidth:50,
            //             visible: true,
            //             showInLegend: false
            //         }));
            //         const categories = ['Chamber'];

            //         return {
            //             chart: {
            //                 type: 'bar',
            //                 height:60,
            //                 marginLeft: 70,
            //                 backgroundColor: 'rgba(0,0,0,0)'
            //             },
            //             exporting: {
            //                 enabled: false,
            //             },
            //             title: {
            //                 text: ''
            //             },
            //             xAxis: {
            //                 categories: categories,
            //                 minPadding: 0,
            //                 maxPadding: 0
            //             },
            //             yAxis:{
            //                 visible: false,
            //                 minPadding: 0,
            //                 maxPadding: 0
            //             },
            //             tooltip: {
            //                 pointFormat: '<span>{series.name}</span>: <b>{point.y} Ministers</b> ({point.percentage:.0f}%)<br/>',
            //             },
            //             plotOptions: {
            //                 bar: {
            //                     stacking: 'percent'
            //                 }
            //             },
            //             legend: {
            //                 visible: false
            //             },
            //             series: series
            //         };
            //     }
            //     return null;
            // },
            // ministryGenderDemographics() {
            //     const series = [ {
            //         name: "Men",
            //         data: [this.MINISTRY_STATS.Ministers - this.MINISTRY_STATS.WomenMinisters],
            //         pointWidth:50,
            //         visible: true,
            //         color: '#8085e9',
            //         showInLegend: false
            //     }, {
            //         name: "Women",
            //         data: [this.MINISTRY_STATS.WomenMinisters],
            //         pointWidth:50,
            //         visible: true,
            //         color: '#f7a35c',
            //         showInLegend: false
            //     }];
            //     const categories = ['Gender'];

            //     return {
            //         chart: {
            //             type: 'bar',
            //             height:60,
            //            marginLeft: 70,
            //             backgroundColor: 'rgba(0,0,0,0)'
            //         },
            //         exporting: {
            //             enabled: false,
            //         },
            //         title: {
            //             text: ''
            //         },
            //         xAxis: {
            //             categories: categories,
            //             minPadding: 0,
            //             maxPadding: 0
            //         },
            //         yAxis:{
            //             visible: false,
            //             minPadding: 0,
            //             maxPadding: 0
            //         },
            //         tooltip: {
            //             pointFormat: '<span>{series.name}</span>: <b>{point.y} Ministers</b> ({point.percentage:.0f}%)<br/>',
            //         },
            //         plotOptions: {
            //             bar: {
            //                 stacking: 'percent'
            //             }
            //         },
            //         legend: {
            //             visible: false
            //         },
            //         series: series
            //     };
            // },
            // ministryCabinetDemographics() {
            //     const series = [ {
            //         name: "Non-Cabinet",
            //         data: [this.MINISTRY_STATS.Ministers - this.MINISTRY_STATS.CabinetMinisters],
            //         pointWidth:50,
            //         visible: true,
            //         showInLegend: false
            //     }, {
            //         name: "Cabinet",
            //         data: [this.MINISTRY_STATS.CabinetMinisters],
            //         pointWidth:50,
            //         visible: true,
            //         showInLegend: false
            //     }];
            //     const categories = ['Cabinet'];

            //     return {
            //         chart: {
            //             type: 'bar',
            //             height:60,
            //            marginLeft: 70,
            //             backgroundColor: 'rgba(0,0,0,0)'
            //         },
            //         exporting: {
            //             enabled: false,
            //         },
            //         title: {
            //             text: ''
            //         },
            //         xAxis: {
            //             categories: categories,
            //             minPadding: 0,
            //             maxPadding: 0
            //         },
            //         yAxis:{
            //             visible: false,
            //             minPadding: 0,
            //             maxPadding: 0
            //         },
            //         tooltip: {
            //             pointFormat: '<span>{series.name}</span>: <b>{point.y} Ministers</b> ({point.percentage:.0f}%)<br/>',
            //         },
            //         plotOptions: {
            //             bar: {
            //                 stacking: 'percent'
            //             }
            //         },
            //         legend: {
            //             visible: false
            //         },
            //         series: series
            //     };
            // },
            // imageSrc: function () {
            //     const template = "https://www.aph.gov.au/-/media/{0}.ashx"
            //     if (this.THISMINISTRY && (this.THISMINISTRY.ImageID != '' && this.THISMINISTRY.ImageID != undefined || this.THISMINISTRY.ImageID != 'Undefined'))
            //         return template.replace("{0}", this.THISMINISTRY.ImageID);
            //     else
            //         return '';
            // },
            MINISTRY: function () {
                if (this.loading) {
                    return []
                }
                var ministry = this.ministryRecords.map(m => ({ ...m, FullRole: `${m.Role}${m.Prep !== '' ? ` ${m.Prep} ${m.Entity}` : ''}` }));

                var consolidatedMinistry = [];
                var isValidToShowCabinetMinister = (this.$moment('1956-01-11') <= this.$moment(this.THISMINISTRY.DateStart) 
                    && this.$moment(this.THISMINISTRY.DateStart) <= this.$moment('1972-12-05'))
                    || this.$moment('1975-12-22') <= this.$moment(this.THISMINISTRY.DateStart);

                let first = undefined;
                let aggregateRole = undefined;
                let aggregateDateStart = undefined;
                let aggregateDateEnd = undefined;
                let arrayRoles = [];
                for (let i = 0; i < ministry.length; i++) {
                    let isCabinetMinister = ministry[i].FullRole === 'Cabinet Minister';
                    let showMinister = (!isCabinetMinister || isCabinetMinister && isValidToShowCabinetMinister);
                    if (showMinister) {
                        if (!first) {
                            first = ministry[i];
                            aggregateRole = first.FullRole;
                            aggregateDateStart = this.formatDate(first.RDateStart, null, null, false);
                            aggregateDateEnd = this.formatDate(first.RDateEnd, null, null, false);
                            arrayRoles.push({ FullRole: first.FullRole, DateStart: this.formatDate(first.RDateStart, null, null, false), DateEnd: this.formatDate(first.RDateEnd, null, null, false) });
                        } else {
                            if (i === ministry.length - 1) {
                                if (first.PHID !== ministry[i].PHID) {
                                    let lastmin = { ...first, FullRole: aggregateRole, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd, SplitRoles: arrayRoles};
                                    consolidatedMinistry.push(lastmin);
                                    arrayRoles = [];
                                    first = ministry[i];
                                    aggregateRole = first.FullRole;
                                    aggregateDateStart = this.formatDate(first.RDateStart, null, null, false);
                                    aggregateDateEnd = this.formatDate(first.RDateEnd, null, null, false);
                                    arrayRoles.push({ FullRole: first.FullRole, DateStart: this.formatDate(first.RDateStart, null, null, false), DateEnd: this.formatDate(first.RDateEnd, null, null, false) });
                                    //push current instance
                                    consolidatedMinistry.push({ ...ministry[i], FullRole: aggregateRole, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd, SplitRoles: arrayRoles });
                                    arrayRoles = [];
                                } else {
                                    if (!aggregateRole.includes(ministry[i].FullRole)) {
                                        aggregateRole = `${aggregateRole}\n${ministry[i].FullRole}`;
                                        aggregateDateStart = `${aggregateDateStart}\n${this.formatDate(ministry[i].RDateStart, null, null, false)}`;
                                        aggregateDateEnd = `${aggregateDateEnd}\n${this.formatDate(ministry[i].RDateEnd, null, null, false)}`;
                                        arrayRoles.push({ FullRole: ministry[i].FullRole, DateStart: this.formatDate(ministry[i].RDateStart, null, null, false), DateEnd: this.formatDate(ministry[i].RDateEnd, null, null, false) });
                                    }
                                    consolidatedMinistry.push({ ...first, FullRole: aggregateRole, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd, SplitRoles: arrayRoles });
                                    arrayRoles = [];
                                }
                            } else {
                                if (first.PHID !== ministry[i].PHID) {
                                    let min = { ...first, FullRole: aggregateRole, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd, SplitRoles: arrayRoles };
                                    consolidatedMinistry.push(min);
                                    arrayRoles = [];
                                    first = ministry[i];
                                    aggregateRole = first.FullRole;
                                    aggregateDateStart = this.formatDate(first.RDateStart, null, null, false);
                                    aggregateDateEnd = this.formatDate(first.RDateEnd, null, null, false);
                                    arrayRoles.push({ FullRole: first.FullRole, DateStart: this.formatDate(first.RDateStart, null, null, false), DateEnd: this.formatDate(first.RDateEnd, null, null, false) });
                                    
                                } else {
                                    if (!aggregateRole.includes(ministry[i].FullRole)) {
                                        aggregateRole = `${aggregateRole}\n${ministry[i].FullRole}`;
                                        aggregateDateStart = `${aggregateDateStart}\n${this.formatDate(ministry[i].RDateStart, null, null, false)}`;
                                        aggregateDateEnd = `${aggregateDateEnd || ' '}\n${this.formatDate(ministry[i].RDateEnd, null, null, false) || ' '}`;
                                        arrayRoles.push({ FullRole: ministry[i].FullRole, DateStart: this.formatDate(ministry[i].RDateStart, null, null, false), DateEnd: this.formatDate(ministry[i].RDateEnd, null, null, false) });
                                    }
                                }
                            }
                        }
                    } else {
                        if (i === ministry.length - 1) {
                            if (first) {
                                if (first.PHID !== ministry[i].PHID) {
                                    let lastmin = { ...first, FullRole: aggregateRole, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd, SplitRoles: arrayRoles };
                                    consolidatedMinistry.push(lastmin);
                                    arrayRoles = [];

                                } else {
                                    consolidatedMinistry.push({ ...first, FullRole: aggregateRole, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd, SplitRoles: arrayRoles });
                                    arrayRoles = [];
                                }
                            }
                        }
                    }
                }

                // make sure that the Prime Minister is always first
                consolidatedMinistry = this._.orderBy(consolidatedMinistry, [m => m.SplitRoles.findIndex(r => r.FullRole === 'Prime Minister'), m => m.RDateStart], ['desc', 'asc'])
                return consolidatedMinistry;
            },
            Name: function () {
                if (this.THISMINISTRY) {
                    return this.THISMINISTRY.Name;
                } else {
                    return '';
                }
            },
            MinistryStart: function () {
                if (this.THISMINISTRY) {
                    return this.THISMINISTRY.DateStart;
                } else {
                    return '';
                }
            },
            MinistryEnd: function () {
                if (this.THISMINISTRY) {
                    return this.THISMINISTRY.DateEnd;
                } else {
                    return '';
                }
            },
            pdfDownloadIcon(){
                return this.pdfDownloading ? 'cached' : 'picture_as_pdf';
            },
            pdfDownloadClass(){
                let pdfClass = 'mr-1';
                if (this.pdfDownloading){
                    pdfClass = pdfClass + ' loading'
                }
                return pdfClass;
            },
            csvDownloadIcon(){
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass(){
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            }
        }
    }</script>
<style scoped>
    a {
        color: #fff;
        text-decoration: none;
    }

    td.handbook-tablecol_linebreaks {
        white-space: pre;
    }

    tr.handbook-tablerow_link {
        cursor: pointer;
    }

    .v-datatable .tr {
        display:table-row;
    }

    .v-datatable a.tr {
        color: #0e1531de;
        text-decoration:none;
        border: 1px solid #dbdbdb;
        border-left: none;
        border-right: none;
    }

    .v-datatable tbody td {
        vertical-align: middle;
    }
</style>
